export default __webpack_public_path__ + "static/img-tuna-500x325-5208a102c68dbb1c98bd6b24a1b51f8f.png";